import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, Meta, SafeHtml, Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import * as mammoth from 'mammoth';


@Component({
	selector: 'app-reglamentobecario',
	templateUrl: './reglamentobecario.component.html',
	styleUrls: ['./reglamentobecario.component.scss']
})
export class ReglamentobecarioComponent implements OnInit {
	title = 'Reglamento del Sorteo Anáhuac para Becados y Colaboradores';
	description = 'Conoce aquí todos los detalles del reglamento el Sorteo Anáhuac 2026 para becados y colaboradores. ';

	htmlContent: SafeHtml = '';
	constructor(
		private titleService: Title,
		private metaTagService: Meta,
		private http: HttpClient,
		private sanitizer: DomSanitizer
	) { }


	ngOnInit(): void {
		this.titleService.setTitle(this.title);
		this.metaTagService.updateTag(
			{ name: 'title', content: this.title }
		);
		this.metaTagService.updateTag(
			{ name: 'description', content: this.description }
		);

		this.metaTagService.updateTag(
			{ property: 'keywords', content: 'Nosotros' }
		);

		this.metaTagService.updateTag(
			{ property: 'og:title', content: this.title }
		);

		this.metaTagService.updateTag(
			{ property: 'og:description', content: this.description }
		);

		this.metaTagService.updateTag(
			{ property: 'og:url', content: environment.URL_WEB + '/nosotros' }
		);

		this.metaTagService.updateTag(
			{ property: 'og:image', content: environment.URL_WEB + '/assets/images/banner2_about.png' }
		);

		this.metaTagService.updateTag(
			{ name: 'twitter:title', content: this.title }
		);
		this.metaTagService.updateTag(
			{ name: 'twitter:description', content: this.description }
		);

		this.cargarLegal();
	}


	cargarLegal() {
		const url = '/assets/docs/reglamento-becario.docx';

		this.http.get(url, { responseType: 'arraybuffer' }).subscribe({
			next: (arrayBuffer: ArrayBuffer) => {
				mammoth.convertToHtml({ arrayBuffer: arrayBuffer })
					.then((result) => {
						// Sanitizamos el HTML generado para inyectarlo de forma segura en la vista
						this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(result.value);

						if (result.messages.length > 0) {
							console.warn('Mensajes de Mammoth:', result.messages);
						}
					})
					.catch((error) => {
						console.error('Error al convertir el documento Word:', error);
					});
			},
			error: (error) => {
				console.error('Error al cargar el archivo de assets:', error);
			}
		});
	}


}
